<template>
    <div class="message">
        <div class="left">
            <div class="left_title">
                <div class="name">聊天发送人</div>
                <!-- <el-dropdown trigger="click" class="dropdown">
                    <img class="img" src="@/assets/message1.png" alt="">
                    <el-dropdown-menu slot="dropdown" class="dropdownMenu">
                        <el-dropdown-item v-for="item in dropdownList" :key="item.id">
                            <div class="item">
                                <img class="itemImg" :src="item.url" alt="">
                                <div class="itemName">{{ item.name }}</div>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
            <div class="left_content">
                <div class="searchHeaderBox">
                    <img class="selectIcon" src="@/assets/unSelectIcon.png" alt="" srcset="">

                    <el-input placeholder="请输入内容" class="searchHeader" v-model="input4">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <newMessageCard class="newMessageCardBox" v-for="item in 40" :key="item" />
            </div>
        </div>
        <div class="center">
            <dialogue></dialogue>
        </div>

        <el-dialog :visible.sync="dialogShow" width="1122px">
            <div class="showDialog">
                <div class="leftInput">
                    <el-input class="dialogInput" type="textarea" placeholder="请输入内容" v-model="textarea">
                    </el-input>
                </div>
                <img class="centerIcon" src="@/assets/dialogIcon.png" alt="">
                <div class="rightInput">{{ textarea }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import newMessageCard from './components/newMessageCard'
import dialogue from './components/dialogue'
export default {
    components: {
       newMessageCard, dialogue
    },
    data() {
        return {
            input4: '',
            dialogShow: false, // 备忘录
            tools: [
                { id: 0, url: require('@/assets/send.png'), name: '发送内容', width: 24, height: 20 },
                { id: 1, url: require('@/assets/link.png'), name: '附加文件', width: 21, height: 21 },
                { id: 2, url: require('@/assets/MP4.png'), name: '发送语音', width: 16, height: 22 },
                { id: 3, url: require('@/assets/eml.png'), name: '发送邮件', width: 20, height: 16 },
            ],
            dropdownList: [
                { id: 0, name: '静音', url: require('@/assets/mute.png') },
                { id: 1, name: '闪烁', url: require('@/assets/flicker.png') },
                { id: 2, name: '喜欢', url: require('@/assets/heart.png') },
            ],
            messageDropdownList: [
                { id: 0, name: '拉黑', url: require('@/assets/mute.png') },
                { id: 1, name: '删除', url: require('@/assets/flicker.png') },
                { id: 2, name: '举报', url: require('@/assets/heart.png') },
            ],
            options: [{
                value: '选项1',
                label: '历史'
            }, {
                value: '选项2',
                label: '历史2'
            }],
            historyValue: '选项1',
            message: '',
            textarea: '',
            infoShow: false,  // 个人信息
        };
    },
    computed: {},
    watch: {},
    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                if (this.$refs.messageList) {
                    this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight;
                }
            });
        },
        // 添加备忘录
        openDialog(show) {
            this.dialogShow = show
        },

        // 查看个人信息
        openInfoDialog(show) {
            this.infoShow = show
        }
    },
    created() {

    },
    mounted() {
        this.scrollToBottom();
    },
    updated() {
        this.scrollToBottom();
    }
}
</script>
<style lang='scss' scoped>
.dropdownMenu {
    width: 120px;

    .item {
        display: flex;
        align-items: center;
        justify-content: center;

        .itemImg {
            width: 20px;
            height: 20px;
            margin-right: 12px;
        }

        .itemName {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
        }
    }
}

::v-deep .el-dialog {
    border-radius: 30px;
}

::v-deep .el-dialog__header {
    padding: 0;
}

::v-deep .el-dialog__body {
    padding: 24px;
}

.message {
    width: 100%;
    margin-top: 8px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 28px;

    .left {
        width: 25%;
        background-color: #fff;
        border-radius: 18px;
        box-sizing: border-box;
        padding: 28px;

        .left_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;

            .name {
                font-weight: 500;
                font-size: 20px;
                color: #333333;
            }

            .dropdown {
                .img {
                    width: 38px;
                    height: 26px;
                    cursor: pointer;
                }
            }
        }

        .left_content {
            box-sizing: border-box;
            overflow-y: auto;
            height: calc(100vh - 210px);

            .newMessageCard {
                margin-bottom: 8px;
            }
        }
    }

    .center {
        width: 72%;
        background-color: #fff;
        border-radius: 18px;
        box-sizing: border-box;
        // padding: 16px;
        display: flex;
        flex-direction: column;
        height: calc(100vh - 100px);

        .center_title {
            width: 100%;
            height: 76px;
            border-radius: 18px;
            box-sizing: border-box;
            padding: 8px 12px;
            background-color: #F7F9FA;
            display: flex;
            align-items: center;
            margin-bottom: 18px;
            flex-shrink: 0;

            .title {
                width: 100%;
                display: flex;
                align-items: center;


                .cards {
                    width: 80%;
                    display: flex;
                    flex-shrink: 0;
                    overflow-x: auto;
                }

                .title_icon {
                    display: flex;
                    align-items: center;
                    margin-left: auto;

                    .imgs {
                        width: 40px;
                        height: 40px;
                        margin-right: 12px;
                        cursor: pointer;
                    }

                    .imgs2 {
                        width: 38px;
                        height: 26px;
                        cursor: pointer;
                    }
                }
            }
        }

        .infoList {
            width: 100%;
            flex: 1;
            overflow-y: auto; // 显示滚动条
            margin-bottom: 16px;
        }

        .input {
            display: flex;
            align-items: center;
            width: 100%;
            flex-shrink: 0;

            .input_info {
                flex: 1;
                height: 216px;
                background-color: #F7F9FA;
                border-radius: 20px;
                margin-right: 16px;
                position: relative;

                .messageInput {
                    width: 100%;
                    height: 100%;
                    background-color: #F7F9FA;
                    border-radius: 20px;
                    box-sizing: border-box;

                    :deep(.el-textarea__inner) {
                        height: 100%;
                        background: #F7F9FA;
                        border: none;
                        border-radius: 20px 4px 20px 20px;
                        padding-left: 50px;
                        padding-top: 14px;
                        resize: none;
                    }

                    :deep(.el-input__count) {
                        color: #999999;
                        background: none;
                        left: 18px;
                    }
                }
            }

            .tools {
                display: flex;
                flex-direction: column;

                .item {
                    display: flex;
                    align-items: center;
                    width: 154px;
                    height: 48px;
                    box-sizing: border-box;
                    padding: 14px 25px;
                    margin-bottom: 8px;
                    background-color: #F7F9FA;
                    border-radius: 8px;
                    cursor: pointer;

                    .item_img {
                        width: 24px;
                        height: 20px;
                        margin-right: 8px;
                    }

                    .item_name {
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                    }
                }

                .item:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .right {
        width: 25%;
        height: calc(100vh - 100px);
        background-color: #fff;
        border-radius: 18px;
        box-sizing: border-box;
        padding: 16px;
        display: flex;
        flex-direction: column;

        .history {
            width: 200px;
            height: 48px;
            box-sizing: border-box;
            padding: 14px 18px;
            background: #F7F9FA;
            border-radius: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;

            :deep(.el-input__inner) {
                border: none;
                background-color: #F7F9FA;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
            }
        }

        .message_list {
            flex: 1;
            overflow-y: auto; // 显示滚动条
        }
    }

    .iconList {
        position: absolute;
        left: 10px;
        top: 12px;
        z-index: 999;

        .icon {
            width: 26px;
            height: 26px;
            margin-bottom: 12px;
            cursor: pointer;
        }
    }
}

.showDialog {
    background-color: #fff;
    width: 100%;
    height: 548px;
    border-radius: 30px;
    display: flex;
    align-items: center;

    .leftInput {
        width: 40%;
        height: 100%;
        background-color: #F7F9FA;

        .dialogInput {
            width: 100%;
            height: 100%;
            background-color: #F7F9FA;
            box-sizing: border-box;

            :deep(.el-textarea__inner) {
                height: 100%;
                background: #F7F9FA;
                border: none;
                padding-top: 14px;
                resize: none;
            }
        }
    }

    .centerIcon {
        width: 40px;
        height: 40px;
        margin: 0 20px;
        cursor: pointer;
    }

    .rightInput {
        flex: 1;
        height: 100%;
        background-color: #F7F9FA;
        box-sizing: content-box;
        padding: 14px 15px 5px;
    }
}

.newMessageCardBox {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

}

.searchHeaderBox {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .selectIcon {
        width: 22px;
        height: 22px;
        margin-right: 14px;
        cursor: pointer;
    }
}

.searchHeader {
    min-width: 248px;
    width: 100%;
    margin-right: 18px;
    :deep(.el-input__inner) {
        border-radius: 10px;
        background-color: #F7F9FA;
        border: none;
    }

}
</style>